<template>
  <v-layout row wrap>
    <v-flex xs12 md6>
      <Card class="availability-card" v-if="selectedTabCompPosition.pos_21 == 'availability'">
        <v-layout row align-center class="header-section px-4 py-2 full-width">
          <div class="header-title subheading primaryText--text">Availability</div>
            <v-spacer></v-spacer>

          <div class="header-legend d-flex align-center">
            <div class="legend-item mr-4">
              <div class="dot up-dot mr-2"></div>
              <span class="legend-text primaryText--text">Up</span>
            </div>

            <div class="legend-item">
              <div class="dot down-dot mr-2"></div>
              <span class="legend-text primaryText--text">Down</span>
            </div>
          </div>
        </v-layout>

        <v-divider class="custom-divider"></v-divider>

          <v-layout column fill-height class="ma-0">
            <v-layout
              v-if="hasPlantData"
              row
              wrap
              class="ma-0"
              :style="{ flex: plantSectionFlex, minHeight: '170px' }"
            >
            <v-flex xs12 md7 class="pa-3 vertical-divider-right">
              <div class="inline-flex-center mb-3">
                <span class="subheading primaryText--text" style="margin-top: -5px;">Plant</span>

                <v-tooltip bottom content-class="ref-device-tooltip">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="ml-1 infoButton"  small>info</v-icon>
                  </template>

                  <div class="pa-2">
                    <p class="mb-1 font-weight-bold tooltip-title">
                      {{ $t('Ref. Device(s)') }}
                    </p>
                    <p class="mb-0 tooltip-text">
                      {{ plantRefDeviceName }}
                    </p>
                  </div>
                </v-tooltip>
              </div>

              <div class="flex-col-center py-0">
                <v-progress-circular
                  :rotate="-90"
                  :size="85"
                  :width="6"
                  :value="widgetData['Plant Availability'] || 0"
                  :color="getDialColor(widgetData['Plant Availability'])"
                  :class="widgetData['Plant Availability'] > 0 ? 'dial-active' : ''"
                >
                  <span class="font-weight-bold value-green">
                  {{ widgetData['Plant Availability'] }}
                  </span>
                </v-progress-circular>
              </div>
            </v-flex>

            <v-flex xs12 md5 class="pa-0">
              <div class="plant-list">
                <SimpleList :data="plantMetricsGroup" />
              </div>
            </v-flex>
          </v-layout>

        <v-divider v-if="hasPlantData && hasGridData" class="custom-divider"></v-divider>

        <v-layout v-if="hasGridData" row wrap class="ma-0" style="flex: 1;">
          <v-flex xs12 md7 class="pa-3 vertical-divider-right">
            <div class="inline-flex-center mb-3">
              <span class="subheading primaryText--text" style="margin-top: -3px;">Grid</span>

              <v-tooltip bottom content-class="ref-device-tooltip">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" class="ml-1 infoButton"  small>info</v-icon>
                </template>

                <div class="pa-2">
                  <p class="mb-1 font-weight-bold tooltip-title">
                    {{ $t('Ref. Device(s)') }}
                  </p>
                  <p class="mb-0 tooltip-text">
                    {{ gridRefDeviceName }}
                  </p>
                </div>
              </v-tooltip>
            </div>

              <v-layout row align-center>
                <v-flex xs5>
                  <div class="flex-col-center">
                    <div class="caption primaryText--text mb-1">Total</div>
                    <v-progress-circular
                      :rotate="-90"
                      :size="85"
                      :width="6"
                      :value="widgetData['Grid Availability'] || 0"
                      :color="getDialColor(widgetData['Grid Availability'])"
                      :class="widgetData['Grid Availability'] > 0 ? 'dial-active' : ''"
                    >
                      <span class="font-weight-bold value-green">
                        {{ widgetData['Grid Availability'] }}
                      </span>
                    </v-progress-circular>
                  </div>
                </v-flex>
                <v-flex xs7 class="pl-3">
                  <div class="text-xs-left">
                    <div class="caption primaryText--text gen-label">
                      {{ $t('Generation hours (5am - 7pm)') }}
                    </div>

                    <v-progress-linear
                      :value="widgetData['value_generation'] || 0"
                      height="10"
                      :color="widgetData['value_generation'] > 0 ? '#1FCF8E' : '#E9952A'"
                      :background-color="widgetData['value_generation'] > 0 ? '#F64E47' : ($vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')"
                      class="mb-1 rounded-bar"
                    ></v-progress-linear>

                    <div class="caption font-weight-bold mb-2 value-green">
                      {{ widgetData['value_generation'] > 0 ? widgetData['value_generation'] + '%' : '0%' }}
                    </div>

                    <div class="caption primaryText--text gen-label">
                      {{ $t('Non generation hours') }}
                    </div>

                    <v-progress-linear
                      :value="widgetData['value_non_generation'] || 0"
                      height="10"
                      :color="widgetData['value_non_generation'] > 0 ? '#1FCF8E' : '#E9952A'"
                      :background-color="widgetData['value_non_generation'] > 0 ? '#F64E47' : ($vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')"
                      class="mb-1 rounded-bar"
                    ></v-progress-linear>

                    <div class="caption font-weight-bold value-green">
                      {{ widgetData['value_non_generation'] > 0 ? widgetData['value_non_generation'] + '%' : '0%' }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md5 class="pa-0">
              <div class="py-2 mt-4 grid-list">
                <SimpleList :data="gridMetricsGroup" />
              </div>
            </v-flex>
          </v-layout>
        </v-layout>

      </Card>
      <Card class="footprint-card" v-else-if="selectedTabCompPosition.pos_21 == 'carbon_footprint'">
        <div class="body-2 text-xs-center align-items-center carbon-footprint__header">
          <img
            :src="require('@/assets/carbon_footprint/footprint.svg')"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2>
          <v-flex>
            <v-layout row wrap justify-center align-center>
              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
      <DataCardSet :items="cardDataSetLeft" v-else-if="selectedTabCompPosition.pos_21 == 'card_left'"/>
      <DataCardSet :items="cardDataSetRight" v-else-if="selectedTabCompPosition.pos_21 == 'card_right'"/>
    </v-flex>
     <v-flex xs12 md6>
      <Card class="availability-card" v-if="selectedTabCompPosition.pos_22 == 'availability'">
        <v-layout row align-center class="header-section px-4 py-2 full-width">
          <div class="header-title subheading primaryText--text">Availability</div>
            <v-spacer></v-spacer>

          <div class="header-legend d-flex align-center">
            <div class="legend-item mr-4">
              <div class="dot up-dot mr-2"></div>
              <span class="legend-text primaryText--text">Up</span>
            </div>

            <div class="legend-item">
              <div class="dot down-dot mr-2"></div>
              <span class="legend-text primaryText--text">Down</span>
            </div>
          </div>
        </v-layout>

        <v-divider class="custom-divider"></v-divider>

          <v-layout column fill-height class="ma-0">
            <v-layout
              v-if="hasPlantData"
              row
              wrap
              class="ma-0"
              :style="{ flex: plantSectionFlex, minHeight: '170px' }"
            >
            <v-flex xs12 md7 class="pa-3 vertical-divider-right">
              <div class="inline-flex-center mb-3">
                <span class="subheading primaryText--text" style="margin-top: -5px;">Plant</span>

                <v-tooltip bottom content-class="ref-device-tooltip">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="ml-1 infoButton"  small>info</v-icon>
                  </template>

                  <div class="pa-2">
                    <p class="mb-1 font-weight-bold tooltip-title">
                      {{ $t('Ref. Device(s)') }}
                    </p>
                    <p class="mb-0 tooltip-text">
                      {{ plantRefDeviceName }}
                    </p>
                  </div>
                </v-tooltip>
              </div>

              <div class="flex-col-center py-0">
                <v-progress-circular
                  :rotate="-90"
                  :size="85"
                  :width="6"
                  :value="widgetData['Plant Availability'] || 0"
                  :color="getDialColor(widgetData['Plant Availability'])"
                  :class="widgetData['Plant Availability'] > 0 ? 'dial-active' : ''"
                >
                  <span class="font-weight-bold value-green">
                  {{ widgetData['Plant Availability'] }}
                  </span>
                </v-progress-circular>
              </div>
            </v-flex>

            <v-flex xs12 md5 class="pa-0">
              <div class="plant-list">
                <SimpleList :data="plantMetricsGroup" />
              </div>
            </v-flex>
          </v-layout>

        <v-divider v-if="hasPlantData && hasGridData" class="custom-divider"></v-divider>

        <v-layout v-if="hasGridData" row wrap class="ma-0" style="flex: 1;">
          <v-flex xs12 md7 class="pa-3 vertical-divider-right">
            <div class="inline-flex-center mb-3">
              <span class="subheading primaryText--text" style="margin-top: -3px;">Grid</span>

              <v-tooltip bottom content-class="ref-device-tooltip">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" class="ml-1 infoButton"  small>info</v-icon>
                </template>

                <div class="pa-2">
                  <p class="mb-1 font-weight-bold tooltip-title">
                    {{ $t('Ref. Device(s)') }}
                  </p>
                  <p class="mb-0 tooltip-text">
                    {{ gridRefDeviceName }}
                  </p>
                </div>
              </v-tooltip>
            </div>

              <v-layout row align-center>
                <v-flex xs5>
                  <div class="flex-col-center">
                    <div class="caption primaryText--text mb-1">Total</div>
                    <v-progress-circular
                      :rotate="-90"
                      :size="85"
                      :width="6"
                      :value="widgetData['Grid Availability'] || 0"
                      :color="getDialColor(widgetData['Grid Availability'])"
                      :class="widgetData['Grid Availability'] > 0 ? 'dial-active' : ''"
                    >
                      <span class="font-weight-bold value-green">
                        {{ widgetData['Grid Availability'] }}
                      </span>
                    </v-progress-circular>
                  </div>
                </v-flex>
                <v-flex xs7 class="pl-3">
                  <div class="text-xs-left">
                    <div class="caption primaryText--text gen-label">
                      {{ $t('Generation hours (5am - 7pm)') }}
                    </div>

                    <v-progress-linear
                      :value="widgetData['value_generation'] || 0"
                      height="10"
                      :color="widgetData['value_generation'] > 0 ? '#1FCF8E' : '#E9952A'"
                      :background-color="widgetData['value_generation'] > 0 ? '#F64E47' : ($vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')"
                      class="mb-1 rounded-bar"
                    ></v-progress-linear>

                    <div class="caption font-weight-bold mb-2 value-green">
                      {{ widgetData['value_generation'] > 0 ? widgetData['value_generation'] + '%' : '0%' }}
                    </div>

                    <div class="caption primaryText--text gen-label">
                      {{ $t('Non generation hours') }}
                    </div>

                    <v-progress-linear
                      :value="widgetData['value_non_generation'] || 0"
                      height="10"
                      :color="widgetData['value_non_generation'] > 0 ? '#1FCF8E' : '#E9952A'"
                      :background-color="widgetData['value_non_generation'] > 0 ? '#F64E47' : ($vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')"
                      class="mb-1 rounded-bar"
                    ></v-progress-linear>

                    <div class="caption font-weight-bold value-green">
                      {{ widgetData['value_non_generation'] > 0 ? widgetData['value_non_generation'] + '%' : '0%' }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md5 class="pa-0">
              <div class="py-2 mt-4 grid-list">
                <SimpleList :data="gridMetricsGroup" />
              </div>
            </v-flex>
          </v-layout>
        </v-layout>

      </Card>
      <Card class="footprint-card" v-else-if="selectedTabCompPosition.pos_22 == 'carbon_footprint'">
        <div
          class="body-2 text-xs-center"
          :style="{
            height: '61px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :src="require('@/assets/carbon_footprint/footprint.svg')"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2 class="align">
          <v-flex>
            <v-layout row wrap justify-center align-center >
              <v-flex md5 class="text-xs-center margin" >
                <img
                  :src="require(`@/assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="extra-sapling-header body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="extra-sapling-header body-2 accent--text">{{ $t('Lifetime') }}</div>
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
      <DataCardSet :items="cardDataSetLeft" v-else-if="selectedTabCompPosition.pos_22 == 'card_left'"/>
      <DataCardSet :items="cardDataSetRight" v-else-if="selectedTabCompPosition.pos_22 == 'card_right'"/>
    </v-flex>
     <v-flex xs12 md6 >
      <Card class="availability-card" v-if="selectedTabCompPosition.pos_23 == 'availability'">
        <v-layout row align-center class="header-section px-4 py-2 full-width">
          <div class="header-title subheading primaryText--text">Availability</div>
            <v-spacer></v-spacer>

          <div class="header-legend d-flex align-center">
            <div class="legend-item mr-4">
              <div class="dot up-dot mr-2"></div>
              <span class="legend-text primaryText--text">Up</span>
            </div>

            <div class="legend-item">
              <div class="dot down-dot mr-2"></div>
              <span class="legend-text primaryText--text">Down</span>
            </div>
          </div>
        </v-layout>

        <v-divider class="custom-divider"></v-divider>

          <v-layout column fill-height class="ma-0">
            <v-layout
              v-if="hasPlantData"
              row
              wrap
              class="ma-0"
              :style="{ flex: plantSectionFlex, minHeight: '170px' }"
            >
            <v-flex xs12 md7 class="pa-3 vertical-divider-right">
              <div class="inline-flex-center mb-3">
                <span class="subheading primaryText--text" style="margin-top: -5px;">Plant</span>

                <v-tooltip bottom content-class="ref-device-tooltip">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="ml-1 infoButton"  small>info</v-icon>
                  </template>

                  <div class="pa-2">
                    <p class="mb-1 font-weight-bold tooltip-title">
                      {{ $t('Ref. Device(s)') }}
                    </p>
                    <p class="mb-0 tooltip-text">
                      {{ plantRefDeviceName }}
                    </p>
                  </div>
                </v-tooltip>
              </div>

              <div class="flex-col-center py-0">
                <v-progress-circular
                  :rotate="-90"
                  :size="85"
                  :width="6"
                  :value="widgetData['Plant Availability'] || 0"
                  :color="getDialColor(widgetData['Plant Availability'])"
                  :class="widgetData['Plant Availability'] > 0 ? 'dial-active' : ''"
                >
                  <span class="font-weight-bold value-green">
                  {{ widgetData['Plant Availability'] }}
                  </span>
                </v-progress-circular>
              </div>
            </v-flex>

            <v-flex xs12 md5 class="pa-0">
              <div class="plant-list">
                <SimpleList :data="plantMetricsGroup" />
              </div>
            </v-flex>
          </v-layout>

        <v-divider v-if="hasPlantData && hasGridData" class="custom-divider"></v-divider>

        <v-layout v-if="hasGridData" row wrap class="ma-0" style="flex: 1;">
          <v-flex xs12 md7 class="pa-3 vertical-divider-right">
            <div class="inline-flex-center mb-3">
              <span class="subheading primaryText--text" style="margin-top: -3px;">Grid</span>

              <v-tooltip bottom content-class="ref-device-tooltip">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" class="ml-1 infoButton"  small>info</v-icon>
                </template>

                <div class="pa-2">
                  <p class="mb-1 font-weight-bold tooltip-title">
                    {{ $t('Ref. Device(s)') }}
                  </p>
                  <p class="mb-0 tooltip-text">
                    {{ gridRefDeviceName }}
                  </p>
                </div>
              </v-tooltip>
            </div>

              <v-layout row align-center>
                <v-flex xs5>
                  <div class="flex-col-center">
                    <div class="caption primaryText--text mb-1">Total</div>
                    <v-progress-circular
                      :rotate="-90"
                      :size="85"
                      :width="6"
                      :value="widgetData['Grid Availability'] || 0"
                      :color="getDialColor(widgetData['Grid Availability'])"
                      :class="widgetData['Grid Availability'] > 0 ? 'dial-active' : ''"
                    >
                      <span class="font-weight-bold value-green">
                        {{ widgetData['Grid Availability'] }}
                      </span>
                    </v-progress-circular>
                  </div>
                </v-flex>
                <v-flex xs7 class="pl-3">
                  <div class="text-xs-left">
                    <div class="caption primaryText--text gen-label">
                      {{ $t('Generation hours (5am - 7pm)') }}
                    </div>

                    <v-progress-linear
                      :value="widgetData['value_generation'] || 0"
                      height="10"
                      :color="widgetData['value_generation'] > 0 ? '#1FCF8E' : '#E9952A'"
                      :background-color="widgetData['value_generation'] > 0 ? '#F64E47' : ($vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')"
                      class="mb-1 rounded-bar"
                    ></v-progress-linear>

                    <div class="caption font-weight-bold mb-2 value-green">
                      {{ widgetData['value_generation'] > 0 ? widgetData['value_generation'] + '%' : '0%' }}
                    </div>

                    <div class="caption primaryText--text gen-label">
                      {{ $t('Non generation hours') }}
                    </div>

                    <v-progress-linear
                      :value="widgetData['value_non_generation'] || 0"
                      height="10"
                      :color="widgetData['value_non_generation'] > 0 ? '#1FCF8E' : '#E9952A'"
                      :background-color="widgetData['value_non_generation'] > 0 ? '#F64E47' : ($vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')"
                      class="mb-1 rounded-bar"
                    ></v-progress-linear>

                    <div class="caption font-weight-bold value-green">
                      {{ widgetData['value_non_generation'] > 0 ? widgetData['value_non_generation'] + '%' : '0%' }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md5 class="pa-0">
              <div class="py-2 mt-4 grid-list">
                <SimpleList :data="gridMetricsGroup" />
              </div>
            </v-flex>
          </v-layout>
        </v-layout>

      </Card>
      <Card class="footprint-card" v-else-if="selectedTabCompPosition.pos_23 == 'carbon_footprint'">
        <div
          class="body-2 text-xs-center"
          :style="{
            height: '61px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :src="require('@/assets/carbon_footprint/footprint.svg')"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2>
          <v-flex>
            <v-layout row wrap justify-center align-center>
              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
      <DataCardSet :items="cardDataSetLeft" v-else-if="selectedTabCompPosition.pos_23 == 'card_left'"/>
      <DataCardSet :items="cardDataSetRight" v-else-if="selectedTabCompPosition.pos_23 == 'card_right'"/>
    </v-flex>
     <v-flex xs12 md6>
      <Card class="availability-card" v-if="selectedTabCompPosition.pos_24 == 'availability'">
        <v-layout row align-center class="header-section px-4 py-2 full-width">
          <div class="header-title subheading primaryText--text">Availability</div>
            <v-spacer></v-spacer>

          <div class="header-legend d-flex align-center">
            <div class="legend-item mr-4">
              <div class="dot up-dot mr-2"></div>
              <span class="legend-text primaryText--text">Up</span>
            </div>

            <div class="legend-item">
              <div class="dot down-dot mr-2"></div>
              <span class="legend-text primaryText--text">Down</span>
            </div>
          </div>
        </v-layout>

        <v-divider class="custom-divider"></v-divider>

          <v-layout column fill-height class="ma-0">
            <v-layout
              v-if="hasPlantData"
              row
              wrap
              class="ma-0"
              :style="{ flex: plantSectionFlex, minHeight: '170px' }"
            >
            <v-flex xs12 md7 class="pa-3 vertical-divider-right">
              <div class="inline-flex-center mb-3">
                <span class="subheading primaryText--text" style="margin-top: -5px;">Plant</span>

                <v-tooltip bottom content-class="ref-device-tooltip">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="ml-1 infoButton"  small>info</v-icon>
                  </template>

                  <div class="pa-2">
                    <p class="mb-1 font-weight-bold tooltip-title">
                      {{ $t('Ref. Device(s)') }}
                    </p>
                    <p class="mb-0 tooltip-text">
                      {{ plantRefDeviceName }}
                    </p>
                  </div>
                </v-tooltip>
              </div>

              <div class="flex-col-center py-0">
                <v-progress-circular
                  :rotate="-90"
                  :size="85"
                  :width="6"
                  :value="widgetData['Plant Availability'] || 0"
                  :color="getDialColor(widgetData['Plant Availability'])"
                  :class="widgetData['Plant Availability'] > 0 ? 'dial-active' : ''"
                >
                  <span class="font-weight-bold value-green">
                  {{ widgetData['Plant Availability'] }}
                  </span>
                </v-progress-circular>
              </div>
            </v-flex>

            <v-flex xs12 md5 class="pa-0">
              <div class="plant-list">
                <SimpleList :data="plantMetricsGroup" />
              </div>
            </v-flex>
          </v-layout>

        <v-divider v-if="hasPlantData && hasGridData" class="custom-divider"></v-divider>

        <v-layout v-if="hasGridData" row wrap class="ma-0" style="flex: 1;">
          <v-flex xs12 md7 class="pa-3 vertical-divider-right">
            <div class="inline-flex-center mb-3">
              <span class="subheading primaryText--text" style="margin-top: -3px;">Grid</span>

              <v-tooltip bottom content-class="ref-device-tooltip">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" class="ml-1 infoButton"  small>info</v-icon>
                </template>

                <div class="pa-2">
                  <p class="mb-1 font-weight-bold tooltip-title">
                    {{ $t('Ref. Device(s)') }}
                  </p>
                  <p class="mb-0 tooltip-text">
                    {{ gridRefDeviceName }}
                  </p>
                </div>
              </v-tooltip>
            </div>

              <v-layout row align-center>
                <v-flex xs5>
                  <div class="flex-col-center">
                    <div class="caption primaryText--text mb-1">Total</div>
                    <v-progress-circular
                      :rotate="-90"
                      :size="85"
                      :width="6"
                      :value="widgetData['Grid Availability'] || 0"
                      :color="getDialColor(widgetData['Grid Availability'])"
                      :class="widgetData['Grid Availability'] > 0 ? 'dial-active' : ''"
                    >
                      <span class="font-weight-bold value-green">
                        {{ widgetData['Grid Availability'] }}
                      </span>
                    </v-progress-circular>
                  </div>
                </v-flex>
                <v-flex xs7 class="pl-3">
                  <div class="text-xs-left">
                    <div class="caption primaryText--text gen-label">
                      {{ $t('Generation hours (5am - 7pm)') }}
                    </div>

                    <v-progress-linear
                      :value="widgetData['value_generation'] || 0"
                      height="10"
                      :color="widgetData['value_generation'] > 0 ? '#1FCF8E' : '#E9952A'"
                      :background-color="widgetData['value_generation'] > 0 ? '#F64E47' : ($vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')"
                      class="mb-1 rounded-bar"
                    ></v-progress-linear>

                    <div class="caption font-weight-bold mb-2 value-green">
                      {{ widgetData['value_generation'] > 0 ? widgetData['value_generation'] + '%' : '0%' }}
                    </div>

                    <div class="caption primaryText--text gen-label">
                      {{ $t('Non generation hours') }}
                    </div>

                    <v-progress-linear
                      :value="widgetData['value_non_generation'] || 0"
                      height="10"
                      :color="widgetData['value_non_generation'] > 0 ? '#1FCF8E' : '#E9952A'"
                      :background-color="widgetData['value_non_generation'] > 0 ? '#F64E47' : ($vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')"
                      class="mb-1 rounded-bar"
                    ></v-progress-linear>

                    <div class="caption font-weight-bold value-green">
                      {{ widgetData['value_non_generation'] > 0 ? widgetData['value_non_generation'] + '%' : '0%' }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md5 class="pa-0">
              <div class="py-2 mt-4 grid-list">
                <SimpleList :data="gridMetricsGroup" />
              </div>
            </v-flex>
          </v-layout>
        </v-layout>

      </Card>
      <Card class="footprint-card" v-else-if="selectedTabCompPosition.pos_24 == 'carbon_footprint'">
        <div
          class="body-2 text-xs-center"
          :style="{
            height: '61px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :src="require('@/assets/carbon_footprint/footprint.svg')"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2>
          <v-flex>
            <v-layout row wrap justify-center align-center>
              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
      <DataCardSet :items="cardDataSetLeft" v-else-if="selectedTabCompPosition.pos_24 == 'card_left'"/>
      <DataCardSet :items="cardDataSetRight" v-else-if="selectedTabCompPosition.pos_24 == 'card_right'"/>
    </v-flex>
  </v-layout>
</template>

<script>
const DataCardSet = () => import("@/components/Plant Overview New/DataCardSet");
import SimpleList from "@/components/common/SimpleList.vue";

export default {
  props: {
    widgetList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    widgetData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    metric: {
      type: Array,
      default: function () {
        return []
      }
    },
    carbonFootprint: {
      type: Object,
      default: function () {
        return {
        emission: {
          today: {
            data: "-",
            unit: "Tons",
          },
          lifetime: {
            data: "-",
            unit: co2ComputedLifeTime.unit,
          },
        },
        sapling: {
          today: {
            data: "-",
            unit: "Nos",
          },
          lifetime: {
            data: "-",
            unit: "Nos",
          },
        },
      };
      }
    },
    cardDataSetLeft: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cardDataSetRight: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectedTabCompPosition: {
      type: Object,
      default: function () {
        return {
          pos_21: "availability",
          pos_22: "carbon_footprint",
          pos_23: "card_left",
          pos_24: "card_right"
        }
      }
    }
  },
  computed: {
    hasPlantData() {
      // Strictly check if Plant Availability exists and is not a default/error value
      const val = this.widgetData["Plant Availability"];
      return "Plant Availability" in this.widgetData && val !== undefined && val !== null && val !== "-";
    },
    hasGridData() {
      // Strictly check if Grid Availability exists and is not a default/error value
      const val = this.widgetData["Grid Availability"];
      return "Grid Availability" in this.widgetData && val !== undefined && val !== null && val !== "-";
    },
    plantMetricsGroup() {
      return this.metric.filter(
        m =>
          m.name.includes("Start") ||
          m.name.includes("Stop") ||
          m.name.includes("Inst. PA")
      );
    },
    gridMetricsGroup() {
      return this.metric.filter(
        m => m.name.includes("Grid Status") || m.name.includes("Grid Down Time")
      );
    },

    plantRefDeviceName() {
      const plantWidgets = [
        "Plant Availability",
        "Instantaneous Plant Availability"
      ];
      const widget = this.widgetList.find(w => plantWidgets.includes(w.name));
      return widget && widget.refDeviceName ? widget.refDeviceName : "Inverter";
    },
    gridRefDeviceName() {
      const gridWidgets = [
        "Grid Availability",
        "Instant Grid Availability"
      ];
      const widget = this.widgetList.find(w => gridWidgets.includes(w.name));
      return widget && widget.refDeviceName ? widget.refDeviceName : "Meter";
    },
    plantSectionFlex() {
      return this.hasGridData ? '0 0 auto' : '1';
    }
  },
  methods: {
    getDialColor(value) {
      return value > 0 ? "#1FCF8E" : "#E9952A";
    }
  },
  components: {
    SimpleList,
    DataCardSet,
  }
};
</script>

<style scoped>
.extra-sapling-header {
  display: none;
}

.card-height-250 {
  min-height: 257px;
  max-height: 257px;
}

.card-title {
  font-size: 15px;
  text-align: center;
  padding: 10px 0 4px 0;
  margin-bottom: 5px;
}

.custom-divider {
  background-color: #334079;
}

.availability-card {
  height: 100%;
  border-radius: 6px;
  box-shadow: 0px 5px 5px 0px #334079;
  overflow: hidden;
}

.footprint-card {
  height: 100%;
  border-radius: 6px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.carbon-footprint__value {
  color: #668cf6;
}

.carbon-footprint__power {
  font-size: 0.7em; /* Adjust font size for the superscript */
  vertical-align: super; /* Align the superscript text */
}

.carbon-footprint__unit {
  color: #aeaeae;
}

#hover__card {
  width: 150px;
  height: 70px;
  padding: 5px;
}

.tool-tip__color {
  background-color: var(--v-primary-base);
  
  border-radius: 5px;
}

.theme--light .tool-tip__color {
  background-color: #ffffff;
  color: #000000;
}

.theme--dark .tool-tip__color {
  background-color: var(--v-grey_4-base);
  color: #ffffff;
} 

.header-section {
  width: 100%;
}

.header-title {
  font-size: 12px;
  white-space: nowrap;
}

.dot {
  min-width: 8px;
  min-height: 8px;
  max-width: 8px;
  max-height: 8px;
  border-radius: 50%;
}

.up-dot {
  background-color: #00e676;
}

.down-dot {
  background-color: #ff5252;
}

.legend-text {
  font-size: 12px;
  
  opacity: 0.8;
}

.rounded-bar {
  border-radius: 10px;
}

.rounded-bar >>> .v-progress-linear__bar__determinate {
  border-radius: 10px;
}

.vertical-divider-right {
  position: relative;
}

.vertical-divider-right::after {
  content: "";
  position: absolute;
  top: 0px; 
  bottom: 0px;
  right: 0px; 
  width: 1px; 
  background-color: #334079;
}



.v-progress-circular >>> .v-progress-circular__underlay {
  stroke: rgba(255,255,255,0.1);
}

.theme--light .v-progress-circular >>> .v-progress-circular__underlay {
  stroke: rgba(0,0,0,0.1);
}

.dial-active >>> .v-progress-circular__underlay {
  stroke: #f64e47 !important;
}

.plant-list {
  height: 100%;
  padding-top: 16px;
  padding-bottom: 19px;  
}

.plant-list ::v-deep > div {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
}

.plant-list ::v-deep .list-item {
  margin-top: 0 !important;
}

.grid-list ::v-deep .list-item {
  padding-top: 16px; 
  padding-bottom: 16px;
}

.infoButton{
  margin-top: -4px;
  cursor: pointer;
}

.gen-label {
  margin-bottom: 1px;
}

.ref-device-label {
  font-size: 14px;
}

.ref-device-name {
  font-size: 12px;
}

.full-width {
  width: 100%;
}

.legend-item {
  display: flex;
  align-items: center;
}

.inline-flex-center {
  display: inline-flex;
  align-items: center;
}

.flex-col-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.value-green {
  color: #00E676;
}

.tooltip-title {
  font-size: 14px;
}

.tooltip-text {
  font-size: 12px;
}

@media (max-width:510px) {
  .footprint-card {
    height: 100%;
  }
}

@media (max-width: 962px) and (min-width:645px) {
  .extra-sapling-header {
    display: block;
  }
}
 @media (max-width: 645px) and (min-width:450px) {
  .align {
    margin: 0px 50px !important;

  }

}
.theme--dark .carbon-footprint__title {
  color: #fff;
}

.theme--light .carbon-footprint__title {
  color: #000;
}

.theme--light .carbon-footprint__icon {
  filter: invert(48%) sepia(12%) saturate(463%) hue-rotate(179deg)
    brightness(98%) contrast(86%);
}

.theme--light .ref-device-tooltip {
  background-color: #E7F1E8 !important;
  color: #000000 !important;
}
.theme--dark .ref-device-tooltip {
  background-color: var(--v-primary-base) !important; 
  color: #ffffff !important;
}

.pl-10 {
  padding-left: 60px;
}

.v-progress-circular {
  font-size: 14px;
}

.custom-divider {
  background-color: #334079;
  border-color: #334079;
}

.subheading {
  font-size: 14px;
  letter-spacing: 1px;
}

.caption {
  font-size: 11px;
  line-height: 1.2;
}
</style>